/**
 * Formats a number into a specified currency string.
 * This uses the modern Intl.NumberFormat API for proper localization.
 *
 * @param {number | string} amount - The numeric value to format.
 * @returns {string} - The formatted currency string (e.g., "₦400,000.00").
 */
export const formatCurrency = (amount) => {
  const locale = 'en-NG';
  const currencyCode = 'NGN';

  const numericAmount = Number(amount);
  if (isNaN(numericAmount)) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
    }).format(0);
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  }).format(numericAmount);
};

/**
 * ✅ THIS IS THE MISSING FUNCTION
 * Returns the correct indefinite article ('a' or 'an') for a given word.
 *
 * @param {string} word - The word to check.
 * @returns {string} - Either "a" or "an".
 */
export const getIndefiniteArticle = (word) => {
  if (!word) return 'a'; // Default to 'a' if the word is empty

  const firstLetter = word.trim()[0].toLowerCase();
  const vowels = ['a', 'e', 'i', 'o', 'u'];

  // This simple check covers most cases for product names.
  if (vowels.includes(firstLetter)) {
    return 'an';
  }
  return 'a';
};